import { useAuth } from "@/contexts";
import { useIsomorphicLayoutEffect } from "@/hooks/Custom";
import Script from "next/script";
import { useState } from "react";

function Konduto() {
  const { isAuthenticated, email } = useAuth();
  const [IsAuth, setIsAuth] = useState(null);
  useIsomorphicLayoutEffect(() => {
    setIsAuth(isAuthenticated);
  }, [isAuthenticated]);
  return (
    <>
      {IsAuth !== null && IsAuth === true && (
        <Script
          id="KONDUTOAUTH"
          strategy="afterInteractive"
          src="/js/KondutoAuth.js"
          about={email}
        />
      )}
      {IsAuth !== null && IsAuth === false && (
        <Script
          id="KONDUTOVISITOR"
          strategy="afterInteractive"
          src="/js/KondutoVisitor.js"
        />
      )}
    </>
  );
}

export { Konduto };
